import { html, rune, View } from 'rune-ts';
import klass from './CommerceSection.module.scss';
import { typo, typoPcMo } from '../../../../../shared/typography/typo';
import { getResizedUrl } from '../../../../../shared/util/image';

export class CommerceSection extends View {
  constructor() {
    super({});
  }

  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    const texts = {
      commerce_title: html.preventEscape(ET(`mps2::landing::plus::commerce_title`)),
      commerce_description: html.preventEscape(
        ET(`mps2::landing::plus::${is_mobile ? 'mo_' : ''}commerce_description`),
      ),
      commerce_product: html.preventEscape(ET(`mps2::landing::plus::commerce_product`)),
      commerce_quality: html.preventEscape(ET(`mps2::landing::plus::commerce_quality`)),
      commerce_platform: html.preventEscape(ET(`mps2::landing::plus::commerce_platform`)),
      commerce_sale: html.preventEscape(ET(`mps2::landing::plus::commerce_sale`)),
      commerce_inventory: html.preventEscape(ET(`mps2::landing::plus::commerce_inventory`)),
      commerce_delivery: html.preventEscape(ET(`mps2::landing::plus::commerce_delivery`)),
    };

    return html`
      <section class="${klass.container}">
        <div class="${klass.content}">
          <div class="${klass.title_wrapper}">
            <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '48_bold', mo: '28_bold' })}">
              ${texts.commerce_title}
            </div>
            <div class="${klass.description} ${typoPcMo({ is_mobile, pc: '20_medium', mo: '14_medium' })}">
              ${texts.commerce_description}
            </div>
          </div>

          <div class="${klass.table}">
            <div class="${klass.row} ${typo('20_bold')}">1 ${texts.commerce_product}</div>
            <div class="${klass.row} ${typo('20_bold')}">2 ${texts.commerce_quality}</div>
            <div class="${klass.row} ${typo('20_bold')}">3 ${texts.commerce_platform}</div>
            <div class="${klass.row} ${typo('20_bold')}">4 ${texts.commerce_sale}</div>
            <div class="${klass.row} ${typo('20_bold')}">5 ${texts.commerce_inventory}</div>
            <div class="${klass.row} ${typo('20_bold')}">6 ${texts.commerce_delivery}</div>
          </div>

          <img
            class="${klass.bg_pc}"
            src="${getResizedUrl({
              url: '//s3.marpple.co/files/u_14345/2024/6/original/plus/section4/pc.png',
              width: 1920 * 2,
              format: 'webp',
              quality: 85,
            })}"
            alt="ip 커머스 예시 pc 이미지"
          />
          <img
            class="${klass.bg_mobile}"
            src="${getResizedUrl({
              url: '//s3.marpple.co/files/u_14345/2024/6/original/plus/section4/mobile.png',
              width: 1920 * 2,
              format: 'webp',
              quality: 85,
            })}"
            alt="ip 커머스 예시 모바일 이미지"
          />
        </div>
      </section>
    `;
  }
}
